import { getBlogsUser, getVlogs } from '../../util/api';

// ================ Action types ================ //

export const GET_BLOGS_REQUEST = 'app/FractionalBlogPage/GET_BLOGS_REQUEST';
export const GET_BLOGS_SUCCESS = 'app/FractionalBlogPage/GET_BLOGS_SUCCESS';
export const GET_BLOGS_ERROR = 'app/FractionalBlogPage/GET_BLOGS_ERROR';

export const GET_VLOGS_REQUEST = 'app/FractionalBlogPage/GET_VLOGS_REQUEST';
export const GET_VLOGS_SUCCESS = 'app/FractionalBlogPage/GET_VLOGS_SUCCESS';
export const GET_VLOGS_ERROR = 'app/FractionalBlogPage/GET_VLOGS_ERROR';

// ================ Reducer ================ //

const initialState = {
  getBlogsInProgress: false,
  getBlogsError: null,
  blogs: [],

  getVlogsInProgress: false,
  getVlogsError: null,
  vlogs: [],
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case GET_BLOGS_REQUEST:
      return { ...state, getBlogsInProgress: true, getBlogsError: null };
    case GET_BLOGS_SUCCESS:
      return { ...state, getBlogsInProgress: false, blogs: payload };
    case GET_BLOGS_ERROR:
      return { ...state, getBlogsInProgress: false, getBlogsError: payload };

    case GET_VLOGS_REQUEST:
      return { ...state, getVlogsInProgress: true, getVlogsError: null };
    case GET_VLOGS_SUCCESS:
      return { ...state, getVlogsInProgress: false, vlogs: payload };
    case GET_VLOGS_ERROR:
      return { ...state, getVlogsInProgress: false, getVlogsError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const getBlogsRequest = () => ({ type: GET_BLOGS_REQUEST });
export const getBlogsSuccess = blogs => ({
  type: GET_BLOGS_SUCCESS,
  payload: blogs,
});
export const getBlogsError = e => ({
  type: GET_BLOGS_ERROR,
  payload: e,
  error: true,
});

export const getVlogsRequest = () => ({ type: GET_VLOGS_REQUEST });
export const getVlogsSuccess = vlogs => ({
  type: GET_VLOGS_SUCCESS,
  payload: vlogs,
});
export const getVlogsError = e => ({
  type: GET_VLOGS_ERROR,
  payload: e,
  error: true,
});

// ================ Thunks ================ //

export const fetchBlogs = () => async (dispatch, getState, sdk) => {
  dispatch(getBlogsRequest());
  try {
    const res = await getBlogsUser();
    dispatch(getBlogsSuccess(res));
  } catch (error) {
    console.error('Error fetching blogs:', error);
    dispatch(getBlogsError(error));
  }
};

export const fetchVlogs = () => async (dispatch, getState, sdk) => {
  dispatch(getVlogsRequest());
  try {
    const res = await getVlogs();
    dispatch(getVlogsSuccess(res?.data || []));
  } catch (error) {
    console.error('Error fetching vlogs:', error);
    dispatch(getVlogsError(error));
  }
};

export const loadData = (params, search, config) => (dispatch, getState) => {
  return Promise.all([
    dispatch(fetchBlogs()),
    dispatch(fetchVlogs()),
  ]);
};
